import { useQuery } from "react-query";
import { getNextProjectNumber } from "../../services/api/api";
import { getProjectPayments } from "../../services/api/manage/manageApi";

export const useFetchNextProjectNumber = (internalProject) => {
    const { isLoading: nextProjectNumberLoading, data: nextProjectNumber } = useQuery(
        "nextProjectNumberQuery",
        () => getNextProjectNumber(internalProject).then(r => r.data),
        {
          staleTime: Infinity,
          retry: 5
        }
      );
    
      return {
        nextProjectNumberLoading,
        nextProjectNumber
      }
}

export const useProjectPayments = (projectId) => {
  const { data, isLoading, refetch } = useQuery(
    ["projectPayments", projectId],
    async () => {
      const { data } = await getProjectPayments(projectId);
      return data;
    },
    {
      enabled: !!projectId,
      staleTime: 30000,
    }
  );

  return {
    payments: data || [],
    paymentsLoading: isLoading,
    refetchPayments: refetch,
  };
};